// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tl-player-image-tooltip{border-radius:.5em;bottom:0;left:0;margin:auto;overflow:hidden;right:0;top:0;transition:none}.tl-player-image-tooltip *{transition:none}.tl-player-image-tooltip__label{font-size:small}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
